import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateUnhappyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2A14 14 0 1 1 2 16 14 14 0 0 1 16 2m5.6 16h-.37a22.7 22.7 0 0 0-5.39 1.09l-.51.18a23 23 0 0 0-2.26 1c-.6.32-1.17.65-1.69 1l-.38.33-.26.18a1 1 0 0 0 1.13 1.65c.1-.08.31-.21.6-.39l.37-.23c.37-.22.77-.45 1.19-.67a18.6 18.6 0 0 1 2.43-1.08l.55-.18a21.4 21.4 0 0 1 4.41-.82h.31a1 1 0 1 0-.1-2ZM12 11a2 2 0 1 0 2 2 2 2 0 0 0-2-2m8 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRateUnhappyFilledSVG);
ForwardRef.displayName = "IconRateUnhappyFilled";
export { ForwardRef as IconRateUnhappyFilled };
